<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps<{
    /** mdi icon name without the "mdi-" prefix (e.g. "magnify"). */
    name: string;
    /** Font size in px. */
    size?: number;
  }>();

  const style = computed(() =>
    props.size ? { fontSize: `${props.size}px` } : undefined
  );
</script>

<template>
  <i class="pos-ui-icon mdi" :class="`mdi-${name}`" :style="style" />
</template>

<style scoped lang="scss">
  .pos-ui-icon {
    @apply tw-inline-flex tw-items-center tw-justify-center tw-leading-none;
  }
</style>
